import React from 'react';
import { Popover, Space, Typography, Avatar } from 'antd';
import moment from 'moment-timezone';
import { getAvatarColor, getProfileUrl } from '../../../utility/utility';
import FeatherIcon from 'feather-icons-react';

const Created = ({ createdAt, createdBy, DateAndTimeFormat }) => {
    return (
        <Popover
            content={
                <Space direction="vertical" size={'small'}>
                    {createdBy && (
                        <>
                            <Typography.Text>
                                <Typography.Text strong>Name: </Typography.Text>
                                {createdBy.firstName} {createdBy.lastName}
                            </Typography.Text>
                            <Typography.Text>
                                <Typography.Text strong>Email: </Typography.Text>
                                {createdBy.email}
                            </Typography.Text>
                            {createdBy?.departments?.length && (
                                <Typography.Text>
                                    <Typography.Text strong>Department(s): </Typography.Text>
                                    {createdBy.departments.map((department) => department.name).join(', ')}
                                </Typography.Text>
                            )}
                        </>
                    )}
                    <Typography.Text>
                        <Typography.Text strong>Created At: </Typography.Text>
                        {moment(createdAt).format(DateAndTimeFormat)}
                    </Typography.Text>
                </Space>
            }
        >
            <Space direction="horizontal" style={{ cursor: 'pointer' }}>
                {moment(createdAt).fromNow()}
                {createdBy && (
                    <Avatar
                        size={'default'}
                        style={{
                            backgroundColor: getAvatarColor(createdBy?.firstName),
                        }}
                        // icon={<FeatherIcon icon="user" size={12} />}
                        src={getProfileUrl({
                            currentUser: createdBy,
                        })}
                    >
                        {createdBy?.firstName.slice(0, 1)} {createdBy?.lastName.slice(0, 1)}
                    </Avatar>
                )}
            </Space>
        </Popover>
    );
};

export default Created;
